import React, { useEffect, useState } from "react";

import {
  CategoryOutlined,
  ChevronLeft,
  LocationOnOutlined,
  NoteOutlined,
  OndemandVideoOutlined,
  QuizOutlined,
  TimerOutlined,
} from "@mui/icons-material";
import {
  Box,
  Card,
  Typography,
  IconButton,
  Tabs,
  Tab,
  CircularProgress,
  Button,
  LinearProgress,
} from "@mui/material";
import { connect, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { EmptyState } from "../../common";
import CandidateAssessmentQnaCard from "../../common/CandidateAssessmentQnaCard";
import CandidateAssessmentUnAttQnaCard from "../../common/CandidateAssessmentUnAttQnaCard";
import ScoreProgressBar from "../../common/ScoreProgressBar";
import {
  getSingleResume as getSingleResumeAction,
  selectResumeById,
} from "../../redux/slices/resumeSlice";
import "../../common/share-button.css";
import ShareResultModal from "../../common/ShareResultModal";
import TranslationToggle from "../../components/InterviewResults/TranslationToggle";
import { getTranslationOfInterview as getTranslationOfInterviewAction } from "../../redux/slices/interviewSlice";
import Lottie from "lottie-react";
import LOADERFORTRA from "../../assets/json/Animation.json";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
/* ============================================================================
<InterviewResultsCandiateFullReport />
============================================================================= */
const InterviewResultsCandiateFullReport = ({
  user,
  getSingleResume,
  getTranslationOfInterview,
}) => {
  const { resumeId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [loaderForTranslation, setLoaderForTranslation] = useState(false);
  const score = 80;
  const [openShareModal, setOpenShareModal] = useState(false);
  const resume = useSelector((state) => selectResumeById(state, resumeId));
  const post = resume?.job;
  const [result, setResult] = useState(
    resume?.result?.length ? resume?.result[0] || {} : {}
  );

  console.log("result", result);
  const [selectedAssessment, setSelectedAssesment] = useState(
    result?.tests?.length ? result?.tests[0] : null
  );

  console.log("selectedAssessment", selectedAssessment);

  const [isEnglish, setIsEnglish] = useState(false);

  const _toggleShareModal = () => setOpenShareModal((prev) => !prev);

  const handleToggle = async (event) => {
    const isChecked = event.target.checked;
    try {
      if (isChecked) {
        if (!selectedAssessment?.questions[0]?.translation) {
          setLoaderForTranslation(true);
          const res = await getTranslationOfInterview(
            result?.id || result?._id
          ).unwrap();
          console.log("res", res?.result[0], res);
          setResult(res?.result[0]);
        }
      }
      // Always update the toggle state
      setLoaderForTranslation(false);
      setIsEnglish(isChecked);
    } catch (error) {
      console.log(error);
      setLoaderForTranslation(false);
    }
  };

  useEffect(() => {}, [result]);

  const handleContainerClick = () => {
    setIsEnglish(!isEnglish);
  };

  useEffect(() => {
    if (!resume) {
      _getData();
    } else {
      setIsLoading(false);
    }
  }, []);

  const _getData = async () => {
    setIsLoading(true);
    await getSingleResume(resumeId);
    setIsLoading(false);
  };
  const extracted_data = resume?.resume?.extracted_data
    ? resume?.resume?.extracted_data
    : resume?.candidate;

  if (!resume) {
    return (
      <Box className="center" height="89vh">
        <EmptyState title="Look's like the resume submition was deleted" />
      </Box>
    );
  }

  return (
    <>
      <Navbar />
      <Sidebar />
      <Card
        sx={{
          m: 4,
          height: "84%",
          borderRadius: "10px",
          ml: { xs: 0, md: "220px" },
        }}
      >
        <Card
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            px: { xs: 2, md: 4 },
            py: 2,
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            gap={{ xs: 0, md: 2 }}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <Box>
              <IconButton
                size="small"
                sx={{ border: "1px solid #B1B1B1" }}
                onClick={() => navigate(-1)}
              >
                <ChevronLeft sx={{ fontSize: 18, color: "#2d2d2d" }} />
              </IconButton>
            </Box>

            <Box>
              <Typography fontSize="18px" fontWeight={600} color="#48555E">
                {resume?.candidate_name}
              </Typography>
              <Typography fontSize="14px" fontWeight={500} color="#48555E">
                {extracted_data?.candidate_email || extracted_data?.email}
              </Typography>
            </Box>
            <Box>
              {extracted_data?.total_relevant_experience?.value ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <NoteOutlined sx={{ fontSize: "15px", color: "#48555E" }} />
                  <Typography fontSize="14px" fontWeight={600} color="#48555E">
                    {
                      resume?.resume?.extracted_data?.total_relevant_experience
                        ?.value
                    }
                  </Typography>
                </Box>
              ) : null}
              {extracted_data?.address?.value ||
              extracted_data?.location?.value ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <LocationOnOutlined
                    sx={{ fontSize: "15px", color: "#48555E" }}
                  />
                  <Typography fontSize="14px" fontWeight={600} color="#48555E">
                    {extracted_data?.address?.value ||
                      extracted_data?.location?.value}
                  </Typography>
                </Box>
              ) : null}
            </Box>
          </Box>
          <Box
            display="flex"
            gap={2}
            justifyContent="center"
            alignItems="center"
          >
            {/* <button
            type="button"
            class="button"
            onClick={() => setOpenShareModal(true)}
          >
            <span class="fold"></span>

            <div class="points_wrapper">
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
            </div>

            <span class="inner">
              <svg
                class="icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
              >
                <polyline points="13.18 1.37 13.18 9.64 21.45 9.64 10.82 22.63 10.82 14.36 2.55 14.36 13.18 1.37"></polyline>
              </svg>
              Share
            </span>
          </button> */}
          </Box>
        </Card>
        <Box display="flex">
          {isLoading ? (
            <Box
              flexBasis="90%"
              flexGrow={1}
              height="70vh"
              overflow="auto"
              className="center"
            >
              <CircularProgress size={35} />
            </Box>
          ) : (
            <Box
              flexBasis="90%"
              flexGrow={1}
              p={3}
              height="70vh"
              overflow="auto"
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                gap={2}
                mt={2}
              >
                <Typography fontSize="35px" fontWeight={700}>
                  {selectedAssessment?.test_name || "--"}
                </Typography>
                <Box display="flex" gap={3} flexWrap="wrap">
                  <Box display="flex" gap={1} alignItems="center">
                    <TimerOutlined
                      sx={{ fontSize: "19px", color: "#595959" }}
                    />
                    <Typography
                      color="#595959"
                      fontWeight={500}
                      fontSize="14px"
                    >
                      {selectedAssessment?.test_time || "--"}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={1} alignItems="center">
                    <QuizOutlined sx={{ fontSize: "19px", color: "#595959" }} />
                    <Typography
                      color="#595959"
                      fontWeight={500}
                      fontSize="14px"
                    >
                      {selectedAssessment?.questions?.length} questions
                    </Typography>
                  </Box>
                  {selectedAssessment?.questions?.find(
                    (q) => q?.question_category === "multiple choice"
                  ) ? (
                    <Box display="flex" gap={1} alignItems="center">
                      <CategoryOutlined
                        sx={{ fontSize: "19px", color: "#595959" }}
                      />
                      <Typography
                        color="#595959"
                        fontWeight={500}
                        fontSize="14px"
                      >
                        Multiple choice
                      </Typography>
                    </Box>
                  ) : null}
                  <Box display="flex" gap={1} alignItems="center">
                    <OndemandVideoOutlined
                      sx={{ fontSize: "19px", color: "#595959" }}
                    />
                    <Typography
                      color="#595959"
                      fontWeight={500}
                      fontSize="14px"
                    >
                      Video
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Typography color="#60738C">
                {selectedAssessment?.test_description || "--"}
              </Typography>

              {/* Pre-Assessment Form Section */}
              {result?.pre_assessment_form_answers?.questions?.length > 0 && (
                <Box
                  mt={3}
                  sx={{
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <Box>
                    <Typography
                      fontFamily="Outfit"
                      fontWeight={700}
                      color="#2C3A4B"
                    >
                      Pre-Assessment Form
                    </Typography>

                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      my={2}
                      sx={{
                        borderRadius: "5px",
                        border: "1px solid #E0E0E0",
                        backgroundColor: "#F8F9FA",
                        p: 2,
                      }}
                    >
                      <Box>
                        <Typography
                          color="#4B5563"
                          fontWeight={500}
                          fontFamily="Outfit"
                        >
                          Candidate completed a pre-assessment questionnaire
                        </Typography>
                        <Typography
                          color="#6B7280"
                          fontSize="14px"
                          fontFamily="Outfit"
                        >
                          {
                            result[0]?.pre_assessment_form_answers?.questions
                              ?.length
                          }{" "}
                          questions answered
                        </Typography>
                      </Box>

                      <Button
                        variant="text"
                        color="primary"
                        sx={{
                          fontWeight: 600,
                          bgcolor: "rgb(75, 199, 225, 0.1)",
                          p: 1,
                          color: "#2a6cec",
                          fontFamily: "Outfit",
                        }}
                        onClick={() => {
                          window.open(
                            `/interview-pre-assessment/${resumeId}`,
                            "_blank"
                          );
                        }}
                      >
                        View Responses
                      </Button>
                    </Box>
                  </Box>
                </Box>
              )}

              <Tabs
                value={selectedAssessment?.test_id} // Use test_id instead of the whole object
                onChange={(_, newTestId) => {
                  // Find the matching test by ID and update selectedAssessment
                  const selectedTest = result?.tests?.find(
                    (test) => test.test_id === newTestId
                  );
                  setSelectedAssesment(selectedTest);
                }}
                sx={{
                  py: 2,
                  "& .MuiTab-root": {
                    pb: 1.5,
                    color: "#000000",
                    bgcolor: "rgb(75, 199, 225, 0.1)",
                    textTransform: "none",
                    fontSize: { xs: "12px", sm: "15px", md: "14px" },
                    fontWeight: 400,
                    fontFamily: "Outfit",
                  },
                }}
              >
                {result?.tests?.map((test) => (
                  <Tab
                    key={test?.test_id}
                    label={test?.test_name || "test name"}
                    value={test.test_id} // Use test_id instead of the whole object
                  />
                ))}
              </Tabs>

              {/* Show only selected assessment data */}
              <div
                style={{
                  padding: "24px",
                  marginTop: 20,
                  marginBottom: 30,
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  backgroundColor:
                    selectedAssessment?.questions?.length > 0
                      ? "#ffffff"
                      : "#FFF7F7",
                }}
              >
                {/* Main score */}
                <div style={{ marginBottom: "34px" }}>
                  <h2
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "500",
                      marginBottom: "16px",
                      color: "#333",
                      fontFamily: "Outfit",
                    }}
                  >
                    Test score{" "}
                    {selectedAssessment?.questions?.length === 0 ? (
                      <span
                        style={{
                          color: "#FF2226",
                          fontSize: "13px",
                          marginLeft: "5px",
                          fontFamily: "Outfit",
                        }}
                      >
                        ( Not-attempted )
                      </span>
                    ) : null}
                  </h2>
                  <ScoreProgressBar
                    value={selectedAssessment?.test_score || 0}
                    color="#36b4e5"
                  />
                </div>

                {/* Skills scores */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                    gap: "16px",
                  }}
                >
                  {/* Technical Skills */}
                  {selectedAssessment?.technical_score !== 420 && (
                    <div>
                      <h3
                        style={{
                          fontSize: "1rem",
                          fontWeight: "500",
                          marginBottom: "8px",
                          color: "#333",
                          fontFamily: "Outfit",
                        }}
                      >
                        Technical Skills{" "}
                      </h3>
                      <ScoreProgressBar
                        value={selectedAssessment?.technical_score || 0}
                        color="#a571f5"
                      />
                    </div>
                  )}

                  {/* Soft Skills */}
                  {selectedAssessment?.soft_skill_score !== 420 && (
                    <div>
                      <h3
                        style={{
                          fontSize: "1rem",
                          fontWeight: "500",
                          marginBottom: "8px",
                          color: "#333",
                          fontFamily: "Outfit",
                        }}
                      >
                        Soft Skills
                      </h3>
                      <ScoreProgressBar
                        value={selectedAssessment?.soft_skill_score || 0}
                        color="#ffb74d"
                      />
                    </div>
                  )}

                  {/* MCQ's Accuracy */}
                  {selectedAssessment?.mcq_score !== 420 && (
                    <div>
                      <h3
                        style={{
                          fontSize: "1rem",
                          fontWeight: "500",
                          marginBottom: "8px",
                          fontFamily: "Outfit",
                          color: "#333",
                        }}
                      >
                        {"MCQ's"} Accuracy
                      </h3>
                      <ScoreProgressBar
                        value={selectedAssessment?.mcq_score || 0}
                        color="#66bb6a"
                      />
                    </div>
                  )}
                </div>
              </div>

              {loaderForTranslation ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "80%",
                    backgroundColor: "#f8f9fa",
                    padding: "2rem",
                  }}
                >
                  {/* Lottie Animation */}
                  <Lottie
                    animationData={LOADERFORTRA}
                    style={{
                      width: "150px",
                      height: "150px",
                      marginBottom: "2rem",
                    }}
                    loop={true}
                    autoplay={true}
                  />

                  {/* Main Title */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      background: "linear-gradient(45deg, #8B5CF6, #06B6D4)",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      textAlign: "center",
                      marginBottom: "1rem",
                      fontFamily: "Outfit",
                      fontSize: { xs: "1rem", md: "1.8rem" },
                    }}
                  >
                    Translating to English
                  </Typography>

                  {/* Progress Bar */}
                  <Box
                    sx={{
                      width: "300px",
                      maxWidth: "90%",
                      marginBottom: "1rem",
                    }}
                  >
                    <LinearProgress
                      sx={{
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: "#E5E7EB",
                        "& .MuiLinearProgress-bar": {
                          background:
                            "linear-gradient(90deg, #8B5CF6, #06B6D4)",
                          borderRadius: 4,
                        },
                      }}
                    />
                  </Box>

                  {/* Subtitle */}
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#929BAE",
                      textAlign: "center",
                      fontSize: "1rem",
                      fontFamily: "Outfit",
                    }}
                  >
                    Just a moment! This is a one-time setup. It’ll be quick.
                  </Typography>
                </Box>
              ) : (
                <>
                  {result?.language !== "English" && (
                    <Box display="flex" justifyContent="flex-end">
                      <TranslationToggle
                        isEnglish={isEnglish}
                        currentLanguage={result?.language}
                        handleContainerClick={handleContainerClick}
                        handleToggle={handleToggle}
                      />
                    </Box>
                  )}

                  {selectedAssessment?.questions?.length > 0 && (
                    <Box
                      gap={1}
                      my={2}
                      sx={{
                        width: "max-content",
                        bgcolor: "#4BC7E1",
                        borderRadius: "30px",
                        px: 2,
                        py: 1,
                      }}
                    >
                      <Typography
                        color="white"
                        textAlign="center"
                        fontSize="16px"
                        fontWeight={600}
                        fontFamily="Outfit"
                      >
                        Attempted questions
                      </Typography>
                    </Box>
                  )}

                  {[...(selectedAssessment?.questions || [])]
                    .sort((a, b) => {
                      // Put introductory message first
                      if (
                        a?.introductory_message === "true" &&
                        b?.introductory_message !== "true"
                      )
                        return -1;
                      if (
                        a?.introductory_message !== "true" &&
                        b?.introductory_message === "true"
                      )
                        return 1;

                      // Put last message at the end (handling both boolean true and string 'true')
                      const aIsLast =
                        a?.last_message === true || a?.last_message === "true";
                      const bIsLast =
                        b?.last_message === true || b?.last_message === "true";

                      if (aIsLast && !bIsLast) return 1;
                      if (!aIsLast && bIsLast) return -1;

                      // Keep original order for other items
                      return 0;
                    })
                    .map((item, index) => (
                      <CandidateAssessmentQnaCard
                        language={
                          result?.language
                            ? isEnglish
                              ? "English"
                              : result?.language
                            : "English"
                        }
                        qna={item}
                        translate={isEnglish}
                        key={index}
                        selectedAssessment={selectedAssessment}
                      />
                    ))}

                  {selectedAssessment?.unattempted_questions?.length > 0 && (
                    <Box
                      gap={1}
                      my={2}
                      sx={{
                        width: "max-content",
                        bgcolor: "#FF2226",
                        borderRadius: "30px",
                        px: 2,
                        py: 1,
                      }}
                    >
                      <Typography
                        color="white"
                        textAlign="center"
                        fontSize="16px"
                        fontWeight={600}
                        fontFamily="Outfit"
                      >
                        Un-attempted questions
                      </Typography>
                    </Box>
                  )}

                  {selectedAssessment?.unattempted_questions?.map(
                    (item, index) => (
                      <CandidateAssessmentUnAttQnaCard
                        language={
                          result?.language
                            ? isEnglish
                              ? "English"
                              : result?.language
                            : "English"
                        }
                        translate={isEnglish}
                        qna={item}
                        key={index}
                      />
                    )
                  )}
                </>
              )}
            </Box>
          )}
        </Box>

        <ShareResultModal
          open={openShareModal}
          onClose={_toggleShareModal}
          title={resume?.candidate_name}
          resumeId={resume?.id}
          type="interview"
        />
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDipatchToProps = {
  getSingleResume: getSingleResumeAction,
  getTranslationOfInterview: getTranslationOfInterviewAction,
};

/* Export
============================================================================= */
export default connect(
  mapStateToProps,
  mapDipatchToProps
)(InterviewResultsCandiateFullReport);
